/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */
import React from 'react';
import { useLinkAnalysisFilterPanelStore } from '../../mothership/linkAnalysisFilterPanel.state';
import { linkAnalysisId } from '../../types';

/*
  Only re-render this component when loading changes
*/
export const LinkAnalysisLoadingAttr = () => {
  const loading = useLinkAnalysisFilterPanelStore((state) => state.loading);
  const id = `${linkAnalysisId}FilterPanel`;
  return <div data-cy={id} data-loading={loading}></div>;
};
